import { Checkbox, type CheckboxProps } from 'antd';
import clx from 'classnames';
import styled from 'styled-components';
import { useInputController } from '../hooks/useInputController.ts';
import { IsBooleanCheckboxElementSymbol } from '../item/symbols/isBooleanCheckboxElement.tsx';
import { useFormItemAccessibility } from '../item/useFormItemAccessibility.tsx';
import { useFormItemEnabled } from '../item/useFormItemEnabled.ts';

const StyledCheckbox = styled(Checkbox)`
  &.read-only {
    pointer-events: none;
  }
`;

export interface ICheckboxInputProps extends Omit<CheckboxProps, 'name'> {
  name: string;
  /**
   * Aggungiamo proprietà readOnly non gestita da antd
   */
  readOnly?: boolean;
  onAfterChange?: (value: boolean) => void;
}

export function CheckboxInput(props: ICheckboxInputProps) {
  const { name, readOnly, className, onAfterChange, ...inputProps } = props;

  const { enabled, visuallyDisabled } = useFormItemEnabled();

  const {
    field: { value, onChange, onBlur, ref },
  } = useInputController(name, { enabled });

  const accessibility = useFormItemAccessibility();

  return (
    <StyledCheckbox
      {...accessibility.attributes}
      disabled={visuallyDisabled}
      {...inputProps}
      // {...field}
      // value={value}
      checked={value}
      onChange={
        readOnly
          ? undefined
          : e => {
              onChange(e.target.checked);
              onBlur();
              onAfterChange?.(e.target.checked);
            }
      }
      ref={ref}
      onClick={readOnly ? undefined : inputProps.onClick}
      className={clx(className, { 'read-only': readOnly })}
    />
  );
}
CheckboxInput[IsBooleanCheckboxElementSymbol] = true;
